// calculateShipping.js
// 运费计算函数 — 导入两个 JSON 文件使用
const postcodeToZone = require('./postcodes.json');
const ratesData = require('./rates.json');

const { markup, rates, weightSurcharges, lengthSurcharges } = ratesData;

/**
 * 计算运费
 * @param {string|number} postcode - 收件邮编
 * @param {number} weight - 实际重量 (kg)
 * @param {number} length - 长 (cm)
 * @param {number} width - 宽 (cm)，默认 30
 * @param {number} height - 高 (cm)，默认 30
 * @returns {number|object} 运费金额或错误时返回 99999
 */
function calculateShipping(postcode, weight = 0, length = 0, width = 30, height = 30) {
  const pc = String(postcode).trim();
  const zone = postcodeToZone[pc];
  if (zone === undefined) {
    //console.log(""Hunter No shipping rule found for this postcode."");
    return 99999;
  }

  const rate = rates[String(zone)];
  if (!rate) {
    //console.log(""Hunter No rate found for this zone."");
    return 99999;
  }

  // 体积重 = L × W × H / 4000
  const cubicWeight = (length * width * height) / 4000;

  // 计费重量 = max(实际重量, 体积重)
  const chargeableWeight = Math.max(weight, cubicWeight);
  const ceiledWeight = Math.ceil(chargeableWeight);

  // 基础运费 = max(basic + ceil(计费重量) × perKg, minimum)
  const baseFreight = rate.basic + ceiledWeight * rate.perKg;
  const effectiveBase = Math.max(baseFreight, rate.minimum);

  // 含加价运费 = 基础运费 × (1 + markup)
  const freightWithMarkup = effectiveBase * (1 + markup);

  // 重量附加费（基于计费重量）
  let weightSurcharge = 0;
  for (const tier of weightSurcharges) {
    if (chargeableWeight >= tier.min && (tier.max === null || chargeableWeight <= tier.max)) {
      weightSurcharge = tier.charge;
      break;
    }
  }

  // 超长附加费（基于最长边）
  const maxDim = Math.max(length, width, height);
  let lengthSurcharge = 0;
  for (const tier of lengthSurcharges) {
    if (maxDim >= tier.min && (tier.max === null || maxDim <= tier.max)) {
      lengthSurcharge = tier.charge;
      break;
    }
  }

  const totalFreight = freightWithMarkup + weightSurcharge + lengthSurcharge;

  return +totalFreight.toFixed(2);
}

module.exports = { calculateShipping };

// === 用法示例 ===
// const { calculateShipping } = require('./hunter');
// or: import { calculateShipping } from './hunter';
//
// const fee = calculateShipping('2006', 15, 90, 30, 30);
// console.log(fee);
// => 74.98
//
// 参数: (postcode, weight, length, width, height)
// 返回: 运费数字，如果无法计算则返回 99999"
